module.exports = __webpack_public_path__ + "static/img/logo.c229f2ee.png";